<template>
  <div class="jwx-pro-forecast__message-block jwx-pro-forecast__out-of-season-block">   
    <p class="jwx-pro-forecast__message-title" data-size="large">The extended forecast is not available at this time.</p>
    <p class="jwx-pro-forecast__message-body" data-size="large">Please try again later.</p>
  </div>
</template>